module.exports = __webpack_public_path__ + "media/images/plans/kaoawase/schedule-1-75b994adc63b16bfca92487adfc118f0.jpg";